import type { PaymentAction } from "./paymentLineItems";

// ─── Types ─────────────────────────────────────────────────────
export interface SubcategoryClaimInfo {
  subcategory_id: string;
  subcategory_name: string;
  category_name: string;
  budget: number;
  claimed_percentage: number;
  claimed_amount: number;
}

export interface ProgressLineItem {
  subcategory_id: string;
  subcategory_name: string;
  category_name: string;
  claimed_percentage: number;
  claimed_amount: number;
  budget: number;
  paid_percentage: number;
  paid_amount: number;
  action: PaymentAction;
  agreed_amount: number | null;
  notes: string;
}

export interface VariationLineItem {
  variation_id: string;
  variation_name: string;
  claimed_amount: number;
  effective_amount: number;
  paid_pct: number;
  paid_amount: number;
  action: PaymentAction;
  agreed_amount: number | null;
  notes: string;
}

export interface RetentionLineItem {
  claimed_amount: number;
  paid_amount: number;
  action: PaymentAction;
  agreed_amount: number | null;
  notes: string;
}

export interface ClaimsReportRow {
  id: string;
  claim_number: number;
  claim_month: number;
  claim_year: number;
  project_id: string;
  total_inc_gst: number | null;
  total_exc_gst: number | null;
  paid_by_builder: number | null;
  calculated_payment_amount?: number | null;
  difference: number | null;
  date_paid: string | null;
  days_before_due: number | null;
  payment_due_date: string | null;
  retention_amount: number | null;
  retention_pct: number | null;
  retention_release_amount?: number | null;
  retention_release_gst?: number | null;
  retention_release_total_inc_gst?: number | null;
  progress_payment_pct?: number | null;
  claimed_to_date?: number | null;
  retention_received_amount?: number | null;
  retention_received_at?: string | null;
  retention_received_notes?: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- JSON column
  variation_payments?: any;
  variations_this_month?: number | null;
  variations_outstanding?: number | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- JSONB from Supabase
  claimed_set?: any | null;
  reconciliation_summary?: unknown;
}

// ─── Constants ─────────────────────────────────────────────────
export const MONTH_SHORT = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

// ─── Helpers ───────────────────────────────────────────────────
export function getNextMonth(month: number, year: number): { month: number; year: number } {
  return month === 12 ? { month: 1, year: year + 1 } : { month: month + 1, year };
}

/** Shorten long Dashpivot docket numbers: "SEQ Formwork-...-733" → "SEQ-733" */
export function shortenDocket(docket: string): string {
  if (!docket) return "Untitled";
  const lastNum = docket.match(/-(\d+)$/)?.[1];
  if (lastNum) return `SEQ-${lastNum}`;
  if (docket.length > 30) return docket.slice(0, 27) + "...";
  return docket;
}

export function sliderGradient(pct: number): string {
  const color =
    pct >= 100 ? "#16a34a"
      : pct >= 75 ? "#22c55e"
        : pct >= 50 ? "#3b82f6"
          : "#60a5fa";
  return `linear-gradient(90deg, ${color} 0%, ${color} ${pct}%, #e2e8f0 ${pct}%, #e2e8f0 100%)`;
}
